import { graphql } from 'react-relay';

export const applyResultContent = graphql`
  query applyResultContentQuery {
    bznavRefund {
      user {
        indis {
          refundId
          applicationDt
          refundResultDt
          paymentDate
          depositExpectDt
          refundAmount
          refundStatus
          refundStage
          cancelStage
          businessInfo {
            taxpayerName
          }
          applicationInfo {
            bank
            accountNo
          }
          virtualAccountInfo {
            owner
            bank
            account
            paymentAmount
          }
          partnerInfo {
            defaultFeeRate
            feeRate
            discountRate
          }
        }
        previousIndis {
          refundId
          applicationDt
          refundResultDt
          paymentDate
          depositExpectDt
          refundAmount
          refundStatus
          refundStage
          cancelStage
          businessInfo {
            taxpayerName
          }
          applicationInfo {
            bank
            accountNo
          }
          virtualAccountInfo {
            owner
            bank
            account
            paymentAmount
          }
          partnerInfo {
            defaultFeeRate
            feeRate
            discountRate
          }
        }
        tritxIndis {
          refundId
          refundAmount
          applicationDt
          refundStatus
          refundStage
          cancelStage
          applicationInfo {
            bank
            accountNo
          }
          businessInfo {
            taxpayerName
          }
          partnerInfo {
            defaultFeeRate
            feeRate
            discountRate
          }
        }
        corps {
          refundId
          applicationDt
          refundResultDt
          depositExpectDt
          refundAmount
          refundStatus
          refundStage
          cancelStage
          paymentDate
          businessInfo {
            hometaxBizName
          }
          applicationInfo {
            bank
            accountNo
          }
          virtualAccountInfo {
            owner
            bank
            account
            paymentAmount
          }
          partnerInfo {
            defaultFeeRate
            feeRate
            discountRate
          }
        }
      }
    }
  }
`;
